import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { buttonsFromSerializedInAppMessage as re } from "../in-app-message-factory.js";
import InAppMessage from "./in-app-message.js";
var ModalMessage = /*#__PURE__*/function (_InAppMessage) {
  _inherits(ModalMessage, _InAppMessage);
  var _super = _createSuper(ModalMessage);
  function ModalMessage(e, r, s, t, i, o, a, p, m, n, u, c, d, f, l, g, j, v, x, z, h, w, y, S, b, k, q, A, B, C) {
    var _this;
    _classCallCheck(this, ModalMessage);
    _this = _super.call(this, e, r, void 0, s, t, i, o, a, p = p || InAppMessage.DismissType.MANUAL, m, n, u, c, d, f, l, g, j, v, x, z, h, w, y, S, b = b || InAppMessage.CropType.FIT_CENTER, void 0, k, q, A, B, C), _this["do"] = InAppMessage.TextAlignment.CENTER;
    return _this;
  }
  _createClass(ModalMessage, [{
    key: "dt",
    value: function dt() {
      return _get(_getPrototypeOf(ModalMessage.prototype), "dt", this).call(this, ModalMessage.es);
    }
  }], [{
    key: "Xr",
    value: function Xr(e) {
      return new ModalMessage(e[InAppMessage.ss.Vr], e[InAppMessage.ss.Wr], e[InAppMessage.ss.xs], e[InAppMessage.ss.Yr], e[InAppMessage.ss.Zr], e[InAppMessage.ss.URI], e[InAppMessage.ss.ra], e[InAppMessage.ss.sa], e[InAppMessage.ss.ta], e[InAppMessage.ss.ia], e[InAppMessage.ss.ns], e[InAppMessage.ss.oa], e[InAppMessage.ss.pa], e[InAppMessage.ss.ma], e[InAppMessage.ss.na], e[InAppMessage.ss.ua], e[InAppMessage.ss.ca], e[InAppMessage.ss.fa], e[InAppMessage.ss.da], e[InAppMessage.ss.la], e[InAppMessage.ss.ga], e[InAppMessage.ss.ja], e[InAppMessage.ss.xa], re(e[InAppMessage.ss.za]), e[InAppMessage.ss.ha], e[InAppMessage.ss.wa], e[InAppMessage.ss.CSS], e[InAppMessage.ss.ya], e[InAppMessage.ss.LANGUAGE], e[InAppMessage.ss.ks]);
    }
  }]);
  return ModalMessage;
}(InAppMessage);
export { ModalMessage as default };
ModalMessage.es = InAppMessage.Ke.Jr;